<template>
  <v-card>
    <NuxtLink :to="{
      name: 'listings-id',
      params: { id: location.url_slug ?? location.id }
    }">
      <v-img
        :src="location.image ?? `/api/map?address=${encodeURIComponent(location?.street + ' ' + location?.house_nr + ', ' + location?.zip + ' ' + location?.city)}`"
        :lazy-src="cardHeaderImage"
        class="align-end"
        aspect-ratio="1.75"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        :alt="location.name!"
        :cover="true"
      >
      </v-img>
      <v-card-text>

        <h3>{{ location.name }}</h3>

        <div
          class="rating"
          v-if="location.settings?.rating"
        >
          <span class="text-accent rating-value mr-2">{{ location.settings?.rating }}</span>

          <v-rating
            :model-value="location.settings.rating"
            color="accent"
            half-increments
            size="15"
            readonly
            :aria-label="'Bewertung: ' + location.settings?.rating + ' von 5'"
          ></v-rating> <span v-if="location.settings?.reviews">({{ location.settings?.reviews }})</span>
        </div>
        <br />
        {{ locationStore.showTodaysOpeningHours(location) }} <br />
        {{ locationStore.calculateClosesInHours(location) }}
      </v-card-text>
    </NuxtLink>

    <v-card-actions>
      <v-spacer></v-spacer>
      <ShareComponent :location="location" />
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import ShareComponent from '../../components/public/ShareComponent.vue'
import { useLocationStore } from '~/store/locationStore';

defineProps({
  location: {
    type: Object,
    required: true,
  },
});

const locationStore = useLocationStore();
const cardHeaderImage = '/images/misc/friseur-salon-no-image.jpg';
</script>
